import { WifiSlashIcon } from '@phosphor-icons/react';

import { Icon } from '@/flavours/glitch/components/icon';

export const LocalOnlyIcon: React.FC = () => {
  return <Icon id='icon' icon={WifiSlashIcon} />;
};
